module.exports = __webpack_public_path__ + "static/intechchat-17302b23a0a74c58489d7f82e559189e.jpg";